
import api from "../../../api/api";


const getAttachmentByGrievanceId = (id) =>{
    return new Promise((resolve, reject)=>{
        api.get("/admin/grievance/attachment/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}


const grievanceAttachmentServices = {
    getAttachmentByGrievanceId,
}
export default grievanceAttachmentServices;